var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card-item transaction shadowless",
      class: _vm.operation.actualOperation ? "owned-by-investor" : "",
    },
    [
      _c(
        "div",
        {
          staticClass: "entity-main-data",
          attrs: { id: "process-result-item" },
        },
        [
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "title" }, [_vm._v(" Operación ")]),
            _c("span", [_vm._v(_vm._s(_vm.operation.companyOperationId))]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "title" }, [_vm._v(" Primera Cuota ")]),
            _c(
              "div",
              [
                _c(
                  "b-tag",
                  {
                    staticClass: "bold",
                    attrs: { rounded: "", type: "is-primary" },
                  },
                  [_vm._v(_vm._s(_vm.operation.firstPaymentNumber))]
                ),
                _c("b-tag", { attrs: { type: "is-medium is-white" } }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.formatDate(_vm.operation.firstPaymentDueDate)
                      ) +
                      " "
                  ),
                ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "title" }, [_vm._v(" Nro. de Cuotas ")]),
            _c("span", [_vm._v(_vm._s(_vm.operation.paymentsQuantity))]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "title" }, [_vm._v(" Valor ")]),
            _c("span", [
              _vm._v(
                "UF " + _vm._s(_vm.formatNumber(_vm.operation.paymentsSum))
              ),
            ]),
          ]),
          _c("div", { staticClass: "check-button" }, [
            _c(
              "a",
              {
                staticClass: "text-not-underline",
                attrs: { id: `check-button-${_vm.pos}`, href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.showDetails(_vm.pos)
                  },
                },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", {
                    staticClass: "fas fa-chevron-up transition-slow",
                    class: { rotate: _vm.extendedEntity !== _vm.pos },
                  }),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "entity-detailed-data content transition-slow",
          class: { show: _vm.extendedEntity === _vm.pos },
          attrs: { id: `extended-detail-${_vm.pos}` },
        },
        _vm._l(_vm.paymentsArray, function (payment, i) {
          return _c("operation-payment-detail", {
            key: `${payment}-${i}`,
            class: _vm.showPaymentState
              ? "entity-details-4-cols"
              : "entity-details-3-cols",
            style: { "--i": i },
            attrs: {
              id: `item-${i}`,
              "operation-id": _vm.operation._id,
              "show-payment": _vm.showPaymentState,
              payment: payment,
              pos: i,
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }